"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _luxon = require("luxon");

var _reactVis = require("react-vis");

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _helpers = require("../../helpers");

var _ChartTick = _interopRequireDefault(require("./ChartTick"));

var _Styles = require("./Styles");

var _colors = require("./colors");

var _chartStyles = require("./chartStyles");

var _ScrollableXYPlot = _interopRequireDefault(require("./ScrollableXYPlot"));

var _ResizableXYPlot = _interopRequireDefault(require("../ResizableXYPlot"));

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  max-width: 100vw;\n  position: relative;\n"])));

var Container = _styled["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n"])));

var createKey = function createKey(dt, zone) {
  return dt.setZone(zone).startOf('hour').toISO();
};

var getTickValues = function getTickValues(startDate, endDate, zone) {
  var daysDiff = (0, _helpers.getDatesBetween)({
    startDate: _luxon.DateTime.fromISO(startDate, {
      zone: zone
    }),
    endDate: _luxon.DateTime.fromISO(endDate, {
      zone: zone
    })
  }, {
    minute: 0,
    second: 0
  }, 'days').length;

  var dateTimeStart = _luxon.DateTime.fromISO(startDate, {
    zone: zone
  }).startOf('day').set({
    hour: 12
  }).toISO();

  var tickValues = Array(daysDiff).fill(null).map(function (none, index) {
    return _luxon.DateTime.fromISO(dateTimeStart, {
      zone: zone
    }).plus({
      days: index
    }).toISO();
  });
  return tickValues;
};

var OneWeekBatteryChart = function OneWeekBatteryChart(_ref) {
  var children = _ref.children,
      startDate = _ref.startDate,
      endDate = _ref.endDate,
      weather = _ref.weather,
      zone = _ref.zone,
      batteryHourly = _ref.batteryHourly,
      mobileWidth = _ref.mobileWidth,
      desktopWidth = _ref.desktopWidth;
  var batteryDictionary = batteryHourly.reduce(function (dictionary, reading) {
    var id = createKey(_luxon.DateTime.fromISO(reading.timeStamp, {
      zone: zone
    }), zone);
    dictionary[id] = reading;
    return dictionary;
  }, {});

  var getIconFromWeather = function getIconFromWeather(tickDate) {
    if (weather && weather.data) {
      var results = weather.data.filter(function (day) {
        return _luxon.DateTime.fromISO(day.date, {
          zone: zone
        }).hasSame(_luxon.DateTime.fromISO(tickDate), 'day');
      });

      if (results.length > 0) {
        return results[0].icon;
      }
    }

    return null;
  };

  var tickFormatter = function tickFormatter(tick) {
    var icon = getIconFromWeather(tick);
    return /*#__PURE__*/_react["default"].createElement(_ChartTick["default"], {
      label: _luxon.DateTime.fromISO(tick, {
        zone: zone
      }).toFormat('M/d'),
      icon: icon
    });
  };

  var hours = (0, _helpers.getDatesBetween)({
    startDate: _luxon.DateTime.fromISO(startDate, {
      zone: zone
    }),
    endDate: _luxon.DateTime.fromISO(endDate, {
      zone: zone
    })
  }, {
    minute: 0,
    second: 0
  }, 'hour');
  var batteryCoordinates = hours.map(function (dt) {
    var x = createKey(dt, zone);
    return {
      x: x,
      y: batteryDictionary[x] && !isNaN(batteryDictionary[x].batteryPercentAverage) ? Number(batteryDictionary[x].batteryPercentAverage) : 0,
      y0: 0
    };
  });

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      selectedCoordinate = _useState2[0],
      setSelectedCoordinate = _useState2[1];

  var hasNoData = Object.keys(batteryDictionary).length === 0;
  var tickValues = [0, 20, 40, 60, 80, 100];
  return /*#__PURE__*/_react["default"].createElement(Wrapper, null, /*#__PURE__*/_react["default"].createElement(Container, null, /*#__PURE__*/_react["default"].createElement(_ScrollableXYPlot["default"], {
    roundedMaxValue: 100,
    tickValues: tickValues,
    widths: {
      mobile: mobileWidth,
      desktop: desktopWidth
    },
    isBattery: true
  }, /*#__PURE__*/_react["default"].createElement(_ResizableXYPlot["default"], {
    margin: {
      left: 0,
      right: 0,
      bottom: 60,
      top: 60
    },
    xType: "ordinal",
    yDomain: [0, 100]
  }, /*#__PURE__*/_react["default"].createElement(_reactVis.HorizontalGridLines, {
    tickValues: tickValues
  }), /*#__PURE__*/_react["default"].createElement(_reactVis.AreaSeries, {
    data: batteryCoordinates,
    style: {
      fill: _colors.BATTERY_OPAQUE,
      stroke: 'none'
    },
    onNearestX: function onNearestX(c, e) {
      setSelectedCoordinate(c);
      e.event.stopPropagation();
    }
  }), selectedCoordinate && batteryDictionary[selectedCoordinate.x] && /*#__PURE__*/_react["default"].createElement(_reactVis.MarkSeries, {
    style: {
      fill: _colors.BATTERY
    },
    lineStyle: {
      stroke: _colors.BATTERY
    },
    markStyle: {
      stroke: _colors.BATTERY
    },
    data: [{
      x: selectedCoordinate.x,
      y: batteryDictionary[selectedCoordinate.x].batteryPercentAverage
    }]
  }), /*#__PURE__*/_react["default"].createElement(_reactVis.LineSeries, {
    data: [{
      x: createKey(hours[0], zone),
      y: 100
    }, {
      x: createKey(hours[hours.length - 1], zone),
      y: 100
    }],
    style: {
      stroke: _colors.BATTERY_OPAQUE
    },
    strokeDasharray: "7, 3"
  }), selectedCoordinate && /*#__PURE__*/_react["default"].createElement(_reactVis.Hint, {
    align: {
      horizontal: 'right',
      vertical: 'bottom'
    },
    marginTop: 0,
    marginLeft: 10,
    marginRight: 10,
    value: selectedCoordinate
  }, /*#__PURE__*/_react["default"].createElement(_Styles.HintBox, null, /*#__PURE__*/_react["default"].createElement(_Styles.HintHeader, {
    color: _colors.BATTERY
  }, _luxon.DateTime.fromISO(selectedCoordinate.x, {
    zone: zone
  }).toFormat('ha')), /*#__PURE__*/_react["default"].createElement(_Styles.HintBody, null, batteryDictionary[selectedCoordinate.x] && /*#__PURE__*/_react["default"].createElement(_Styles.HintValue, null, "".concat(parseFloat(batteryDictionary[selectedCoordinate.x].batteryPercentAverage).toFixed(2), "% Charged"))))), /*#__PURE__*/_react["default"].createElement(_reactVis.Borders, {
    style: _chartStyles.borderStyle
  }), /*#__PURE__*/_react["default"].createElement(_reactVis.XAxis, {
    style: _chartStyles.xAxisStyle,
    tickValues: getTickValues(startDate, endDate, zone) // Every day in at hour 12
    ,
    tickFormat: function tickFormat(v) {
      return tickFormatter(v);
    }
  }))), hasNoData && children && /*#__PURE__*/_react["default"].createElement(_Styles.FillAvailableSpace, null, children)));
};

OneWeekBatteryChart.propTypes = {
  children: _propTypes["default"].node,
  batteryHourly: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    batteryPercentAverage: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
    timeStamp: _propTypes["default"].string
  })),
  weather: _propTypes["default"].shape({
    data: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      date: _propTypes["default"].string.isRequired,
      icon: _propTypes["default"].string.isRequired,
      temperature: _propTypes["default"].number.isRequired
    }))
  }),
  zone: _propTypes["default"].string,
  startDate: _propTypes["default"].string.isRequired,
  endDate: _propTypes["default"].string.isRequired,
  mobileWidth: _propTypes["default"].string,
  desktopWidth: _propTypes["default"].string
};
OneWeekBatteryChart.defaultProps = {
  children: undefined,
  batteryHourly: [],
  weather: {
    data: []
  },
  zone: 'local',
  mobileWidth: '1000px',
  desktopWidth: '100%'
};
var _default = OneWeekBatteryChart;
exports["default"] = _default;